import {Box, Text} from '@mantine/core';
import {BasicButton} from '@packages/ui';
import type {FC} from 'react';
import {getMailAuthLinkWithParamsHooks} from '../../services/getMailAuthLinkWithParamsHooks';

export const SignUp: FC = () => {
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  return (
    <Box className="flex h-[200px] w-[300px] flex-col bg-white p-[15px]">
      <Text className="text-base text-black-1">
        <span className="font-bold">外資就活ドットコム</span>
        に会員登録すると、様々な就職支援サービス をご利用いただけます。現在、
        <span className="font-bold">
          会員の約7割が東大・京大・慶応・早稲田・科学大・一橋大などの
        </span>
        上位校の学生です
      </Text>
      <BasicButton
        className="mt-[12px]"
        children="新規会員登録"
        isPrimary={true}
        isLarge={true}
        onClick={() => {
          location.href = mailAuthLink;
        }}
      />
    </Box>
  );
};
